import { render, staticRenderFns } from "./forgetFinish.vue?vue&type=template&id=2845ffc4&scoped=true"
import script from "./forgetFinish.vue?vue&type=script&lang=js"
export * from "./forgetFinish.vue?vue&type=script&lang=js"
import style0 from "./forgetFinish.vue?vue&type=style&index=0&id=2845ffc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2845ffc4",
  null
  
)

export default component.exports